/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  GenerateExportByKeyMutationRequest,
  GenerateExportByKeyMutationResponse,
} from "../types/GenerateExportByKey.ts"
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { mutationOptions, useMutation } from "@tanstack/react-query"

export const generateExportByKeyMutationKey = () =>
  [{ url: "/v1/export/generate-by-key" }] as const

export type GenerateExportByKeyMutationKey = ReturnType<
  typeof generateExportByKeyMutationKey
>

/**
 * @summary Generate export by configuration key
 * {@link /v1/export/generate-by-key}
 */
export async function generateExportByKey(
  data: GenerateExportByKeyMutationRequest,
  config: Partial<RequestConfig<GenerateExportByKeyMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    GenerateExportByKeyMutationResponse,
    ResponseErrorConfig<Error>,
    GenerateExportByKeyMutationRequest
  >({
    method: "POST",
    url: `/v1/export/generate-by-key`,
    data: requestData,
    ...requestConfig,
  })
  return res
}

export function generateExportByKeyMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<GenerateExportByKeyMutationRequest>> & {
    client?: Client
  } = {}
) {
  const mutationKey = generateExportByKeyMutationKey()
  return mutationOptions<
    ResponseConfig<GenerateExportByKeyMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: GenerateExportByKeyMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return generateExportByKey(data, config)
    },
  })
}

/**
 * @summary Generate export by configuration key
 * {@link /v1/export/generate-by-key}
 */
export function useGenerateExportByKey<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<GenerateExportByKeyMutationResponse>,
      ResponseErrorConfig<Error>,
      { data: GenerateExportByKeyMutationRequest },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig<GenerateExportByKeyMutationRequest>> & {
      client?: Client
    }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey =
    mutationOptions.mutationKey ?? generateExportByKeyMutationKey()

  const baseOptions = generateExportByKeyMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<GenerateExportByKeyMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: GenerateExportByKeyMutationRequest },
    TContext
  >

  return useMutation<
    ResponseConfig<GenerateExportByKeyMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: GenerateExportByKeyMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<GenerateExportByKeyMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: GenerateExportByKeyMutationRequest },
    TContext
  >
}
